import { createFileRoute } from '@tanstack/react-router';
import { BinEventsForm } from '@amber-ui/core';

function BinEventsRoute() {
  const { bin } = Route.useSearch();

  if (!bin) return null;

  return <BinEventsForm grain_bin_id={bin} />;
}

export const Route = createFileRoute('/_auth/_grain-bin/grain_bin/events')({
  component: BinEventsRoute,
});
